import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
import api from '../services/api';
import LazyImage from '../components/LazyImage';
import { Page, Header, Images, Body } from './NewsPostStyles';

const NewsPost = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    api.news.getPost(id)
      .then(data => { if (mounted) setPost(data); })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
    return () => { mounted = false; };
  }, [id]);

  if (loading) return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Oval height={48} width={48} color="#2E8B57" secondaryColor="#CDEAD7" />
    </div>
  );
  if (error) return <div style={{ padding: 20 }}>Error: {error}</div>;
  if (!post) return null;

  const date = post.publishedAt ? new Date(post.publishedAt) : null;

  return (
    <Page>
      <Header>
        <h1>{post.title}</h1>
        <p>{date ? date.toLocaleDateString() : ''}</p>
      </Header>
      <Images>
        {(post.images || []).map((src, idx) => (
          <LazyImage key={idx} src={src} alt={`${post.title} ${idx + 1}`} />
        ))}
      </Images>
      <Body>
        <p>{post.description}</p>
      </Body>
    </Page>
  );
};

export default NewsPost;
